// extracted by mini-css-extract-plugin
module.exports = {"contentLayout":"styles_contentLayout__3qYsF","content":"styles_content__1NrcQ"};